const POST_TYPE_EXCEPTIONS = [
	'page',
	'post',
	'attachment',
	'nelio_popup',
	'nelio_form',
	'elementor_library',
	'e-floating-buttons',
	'nab_elementor_popup',
	'sc_product',
	'wp_block',
];

const POST_TYPE_EXCEPTIONS_WITH_WOOCOMMERCE = [
	...POST_TYPE_EXCEPTIONS,
	'product',
	'product_variation',
];

export const getPostTypeExceptions = ( {
	isWooCommerceEnabled,
}: {
	isWooCommerceEnabled: boolean;
} ): ReadonlyArray< string > =>
	isWooCommerceEnabled
		? POST_TYPE_EXCEPTIONS_WITH_WOOCOMMERCE
		: POST_TYPE_EXCEPTIONS;
